import { render } from "./ContactView.vue?vue&type=template&id=04388f3a&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=04388f3a&scoped=true&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04388f3a"]])

export default __exports__